<layout>
<div class="background">
  <div class="inset" [@trigger]=currentState >
    <h1>{{config?.contactUsH1}}</h1>
    <p>{{config?.contactUsB1a}}
      <br><br>{{config?.contactUsB1b}}  <span class="BoldText">{{config?.contactUsNumber}}</span>
      <br><br>{{config?.contactUsB1c}}
     </p>
    <div class="horizontalLine "></div>
    <p>{{config?.contactUsB2}}</p>
     <form (ngSubmit)="submitMessage()">
        <input type="checkbox" id="c1" name="cc" [(ngModel)]="bibleQuestion" />
        <label for="c1"><span></span>{{config?.contactUsOption1}}</label><br>
        
        <input type="checkbox" id="c2" name="cc" [(ngModel)]="supportQuestion" />
        <label for="c2"><span></span>{{config?.contactUsOption2}}</label><br>

        <input type="checkbox" id="c3" name="cc" [(ngModel)]="prayerRequest" />
        <label for="c3"><span></span>{{config?.contactUsOption3}}</label><br>
        
        <input type="checkbox" id="c4" name="cc" [(ngModel)]="other" /> 
        <label for="c4"><span></span>{{config?.contactUsOption4}}</label><br>
        


        <input id="name" class="short" name="name" type="text" placeholder={{config?.contactUsNamePlaceholder}} [(ngModel)]="name"><br>
        <input id="email" class="short" name="email" type="email" placeholder={{config?.contactUsEmailPlaceholder}} [(ngModel)]="email"><br>
        <textarea id="message" class="message" name="moreinfo" cols="60" rows="10" placeholder={{config?.contactUsMessagePlaceholder}} required="required" [(ngModel)]="message">
          </textarea><br>
          <div class="alert hideMessage" [ngClass]="{showMessage : verificationMessage, hideMessage:!verificationMessage}">
              <span class="closebtn" (click)="hideSuccessMessage()">&times;</span> 
              <strong>{{config?.contactUsMessage1}}</strong> {{config?.contactUsMessage2}}
            </div>
          <div class="errorAlert hideMessage" [ngClass]="{showMessage : errorMessage, hideMessage:!errorMessage}">
              <span class="closebtn" (click)="hideErrorMessage()">&times;</span> 
              <strong>{{errorMessage}}</strong> 
            </div>

        <button class="buttonConfig">{{config?.contactUsSend}}</button>
        <div style="width: 100%; height: 0; padding-bottom: 50%"></div>
  </form>
  </div>
</div>
</layout>